import isNil from "~/kernel/validation/isNil";

type Props = { error: string | undefined | null };

export default function FieldError({ error }: Props) {
  if (isNil(error)) {
    return null;
  }

  return <div className="text-sm text-error">{error}</div>;
}
